import { render, staticRenderFns } from "./CostBearersForm.vue?vue&type=template&id=1bb092e5"
import script from "./CostBearersForm.vue?vue&type=script&lang=ts"
export * from "./CostBearersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports